import { useSearchParams } from 'react-router-dom'
import { useCallback } from 'react'

/**
 * Syncs tab state with URL query parameter (?tab=<value>).
 * Drop-in replacement for useState in tab-based pages.
 * Uses replace: true to avoid polluting browser history on tab clicks.
 *
 * Usage:
 *   const [tab, setTab] = useTabParam('overview')
 *   <TabContext value={tab}>
 *     <TabList onChange={(_e, v) => setTab(v)}>
 */
export default function useTabParam(defaultTab = '1') {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') || defaultTab

  const setTab = useCallback((newTab) => {
    setSearchParams({ tab: newTab }, { replace: true })
  }, [setSearchParams])

  return [tab, setTab]
}
